import { useState, useEffect, FC } from 'react'
import { AssistantAction, getAssistantIllustration } from '@/hooks/useAssistantIllustration'
import './TransitionScreen.scss'

const TRANSITION_DURATION = 3000
const FLIP_START_DELAY = 500
const IMAGE_SWITCH_RATIO = 1 / 3
const MMA_ILLU_DEFAULT = getAssistantIllustration()
const MMA_ILLU_WAVING = getAssistantIllustration(AssistantAction.WAVING)

interface TransitionScreenProps {
    isVisible: boolean
    onTransitionComplete?: () => void
    duration?: number
    isDarkTheme?: boolean
}

const TransitionScreen: FC<TransitionScreenProps> = ({ 
    isVisible,
    onTransitionComplete,
    duration = TRANSITION_DURATION,
    isDarkTheme = false
}) => {
    const [isFlipping, setIsFlipping] = useState(false)
    const [showGreenImage, setShowGreenImage] = useState(false)

    useEffect(() => {
        if (!isVisible) {
            setIsFlipping(false)
            setShowGreenImage(false)
            return
        }

        const flipTimer = setTimeout(() => setIsFlipping(true), FLIP_START_DELAY)
        const switchTimer = setTimeout(() => setShowGreenImage(true), duration * IMAGE_SWITCH_RATIO)
        const completeTimer = setTimeout(() => onTransitionComplete?.(), duration)

        return () => {
            clearTimeout(flipTimer)
            clearTimeout(switchTimer)
            clearTimeout(completeTimer)
        }
    }, [isVisible, duration, onTransitionComplete])

    if (!isVisible) return null

    const imageSrc = showGreenImage ? MMA_ILLU_WAVING : MMA_ILLU_DEFAULT
    const themeClass = isDarkTheme ? 'transition-screen--dark' : 'transition-screen--light'
    const flipClass = isFlipping ? 'flipping' : ''

    return (
        <div className={`transition-screen ${themeClass}`}>
            <div className={`transition-screen__content ${flipClass}`}>
                <img
                    src={imageSrc}
                    alt="MMA Illustration"
                    className="transition-screen__image"
                />
            </div>
        </div>
    )
}

export default TransitionScreen
